import { redirect } from "@tanstack/react-router"
import { createServerFn } from "@tanstack/react-start"
import { z } from "zod"

import { parseFormData } from "@/form"

import { getRedirectUrl, verifyPasswordCredentials } from "../auth.server"
import { setSessionCookie } from "../session.server"

export const loginWithPasswordFormSchema = z.object({
  email: z.string().email("Enter a valid email address"),
  password: z.string().min(1, "Enter your password"),
  redirectTo: z.string().optional(),
})

const PASSWORD_ERRORS = {
  INVALID_CREDENTIALS: "Email or password is incorrect. Try again.",
} as const

export const loginWithPasswordAction = createServerFn({ method: "POST" })
  .validator((data: FormData) => parseFormData(loginWithPasswordFormSchema, data))
  .handler(async ({ data }) => {
    const result = await verifyPasswordCredentials(data.email, data.password)
    if (!result.ok) {
      // ponytail: BUG 6 fix — never expose TOO_MANY_ATTEMPTS to client.
      // Both rate-limited accounts and nonexistent accounts return the same error.
      // This prevents status-code enumeration that would leak which emails are real.
      const errorCode = result.code === "TOO_MANY_ATTEMPTS" ? "INVALID_CREDENTIALS" : result.code
      return { error: PASSWORD_ERRORS[errorCode] }
    }
    await setSessionCookie(result.userId)
    throw redirect({ to: getRedirectUrl(data.redirectTo) })
  })
